/**************************************************
 * Nombre:       Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Camino from "./SubComponentes/Camino";
import Tarjeta_Persona from "../../Tarjetas/Tarjeta_Persona";
import caficultor from '../../../Recursos/caficultor.svg'
import proceso from '../../../Recursos/proceso.svg'
import SolicitaMuestrario from "./SubComponentes/SolicitaMuestrario";
import ImagenesProducto from "./SubComponentes/ImagenesProducto";
import fondo from '../../../Recursos/fondo_detalles.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../../Servicios/BD/obtenerDoc";

const Detalle_Producto = () => {
    const params = useParams()
    const {sCell, masSM} = useResponsive()
    const [varitetal, setVaritetal] = useState({})

    useEffect(() => {

        if (params && params.id) {
            obtenerDoc('varietales', params.id).then((dox) => {
                if (dox.res) {
                    setVaritetal(dox.data)
                }
            })
        }

    }, [params])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', pr: !masSM ? 0 : 6}}>
                                    <ImagenesProducto item={varitetal}/>
                                </Grid>

                                {!sCell &&
                                    <Grid container size={{xs: 12, sm: 12, md: 10}}
                                          sx={{justifyContent: 'flex-start', mt: 12}}>
                                        <Camino/>
                                    </Grid>
                                }

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: 300
                                    }}>{`Varietal ${varitetal.categoria ? varitetal.categoria : ''}`}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 40, fontWeight: 800}}>{varitetal?.nombre}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mb: 8}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                        {varitetal?.descripcion}
                                    </Typography>
                                </Grid>


                                <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Persona item={{
                                        img: caficultor,
                                        nombre: varitetal?.caficultor,
                                        descripcion: 'Caficultor'
                                    }}/>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Persona item={{
                                        img: proceso,
                                        nombre: varitetal?.procesos,
                                        descripcion: 'Proceso'
                                    }}/>
                                </Grid>


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 8}}>
                                    <Typography sx={{fontSize: sCell ? 24 : 32, fontWeight: 800}}>Perfil
                                        Sensorial</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mb: 0}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                        {varitetal?.perfil}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 6}}>
                                    <Typography sx={{fontSize: sCell ? 24 : 32, fontWeight: 800}}>Proceso de
                                        beneficio</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mb: 8}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                        {varitetal?.proceso}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 14}}>
                            <SolicitaMuestrario/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Producto

const uno = {
    img: caficultor,
    nombre: 'Jhon Gomez',
    descripcion: 'Caficultor'
}

const dos = {
    img: proceso,
    nombre: 'Diego F. Portilla C.',
    descripcion: 'Proceso'
}